export default __webpack_public_path__ + "static/media/IBMPlexSans-Light.470d7ab3.woff";